module.exports = __webpack_public_path__ + "img/ns_safe.062f5e4b.jpg";